<script>
import { formatDate, DateUtil } from '@/utils/date.js'
import { StringUtil } from '@/utils/StringUtil.js'
import dialog from '@/components/Dialog'
import driver from '@/components/driver'
import CalendarInput from '@/components/CalendarInput'
import addressChoice from '@/components/AddressChoice'
import mapDropPin from '../assets/map_icon/map_drop_pin.png'
// 从地图上选择的自宅住所地址
var mHomeAddressChoiceByMap = ''
export default {
  components: {
    // dialog 弹出框组件
    'v-dialog': dialog,
    driver: driver,
    // 日历组件
    CalendarInput,
    // 地图弹出框组件
    addressChoice
  },
  data () {
    return {
      // message提示弹出框配置信息
      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 三张图片URL
      option: {
        img1: null,
        file1: null,
        img2: null,
        file2: null,
        img3: null,
        file3: null
      },
      // 上传图片的大小
      uploadPictureMaxSize: 5,
      // user年龄
      age: 0,
      // 地图中心点
      centerPoint: {
        lat: 35.709,
        lng: 139.731
      },
      mapId: 'autoAdressMap',
      birthday: '',
      // 会員checkbox
      userCheckbox: false,
      // ドライバーcheckbox
      driverCheckbox: false,
      // 管理者checkbox
      adminCheckbox: false,
      // 交通事業者checkbox
      transportCheckbox: false,
      // 管理者单选按钮
      permissionRadio: null,
      // チェックボックス管理フラグ
      transportEnabled: false,
      fureaiEnabled: false,
      // 交通事業者選択
      transportSelect: null,
      // 交通事業者一覧
      transportInfoList: [],
      // 交通事業者名
      transportName: ''
    }
  },
  // UserLogin传过来参数
  props: {
    // 画面title
    title: { type: String, default: '' },
    // 按钮名
    btnName: { type: String, default: '' },
    // ユーザープロフィール情報
    userProfileModel: {},
    // ドライバープロフィール情報
    userDriverProfileModel: {},
    // 交通事業者プロフィール情報
    userTransportDriverProfileModel: {},
    // ユーザーアカウント情報
    userAccountModel: {},
    // 会員checkbox
    userCheckboxs: { type: Boolean, default: false },
    // ドライバーcheckbox
    driverCheckboxs: { type: Boolean, default: false },
    // 管理者checkbox
    adminCheckboxs: { type: Boolean, default: false },
    // 交通事業者checkbox
    transportCheckboxs: { type: Boolean, default: false },
    // 管理者单选按钮
    permissionRadios: { type: Number, default: null },
    // 登録日 默认：系统当前日期 格式：yyyy年MM月dd日
    inTime: { type: String, default: DateUtil.dateToString(new Date()) },
    // ドライバー登録日 默认：系统当前日期 格式：yyyy年MM月dd日
    driverInTime: { type: String, default: DateUtil.dateToString(new Date()) },
    // 生年月日：年
    birthdayYear: {type: Number, default: 1970},
    // 生年月日：月
    birthdayMonth: { type: Number, default: 1 },
    // 生年月日：日
    birthdayDay: {type: Number, default: 1},
    // 免許証有効期限:年
    driverLicenseDeadlineYear: {type: Number, default: new Date().getFullYear()},
    // 免許証有効期限:月
    driverLicenseDeadlineMonth: { type: Number, default: new Date().getMonth() + 1 },
    // 免許証有効期限:日
    driverLicenseDeadlineDay: {type: Number, default: new Date().getDate()},
    // 活動年数
    activityYear: { type: String, default: '１ヶ月' },
    // 不同功能的标志位 0:アカウント登録 1:アカウントを編集
    functionFlag: {type: String, default: '0'},
  },
  watch: {
    // 管理者CheckBox与两个radio的联动处理
    adminCheckbox (newvalue) {
      if (newvalue === true) {
        // 管理者CheckBox被选中，一般radio默认被选中
        if (this.permissionRadio === null) {
          this.permissionRadio = 0
        }
        this.transportCheckbox = false;
      } else {
        // 管理者checkbox不被选中，radio不被选中
        this.permissionRadio = null
      }
      if(this.userCheckbox || this.driverCheckbox || newvalue){
        this.fureaiEnabled = true
      }else{
        this.fureaiEnabled = false
      }
    },
    permissionRadio (newvalue) {
      if (newvalue !== null) {
        this.adminCheckbox = true
      }
    },
    'userProfileModel.postalcode' (oldVal, newValue) {
      if (oldVal === newValue) {
      }
    },

    // チェックボックスの有効無効切り替え
    // 交通事業者のチェックボックスとそれ以外は排他とする
    transportCheckbox(newvalue) {
      this.transportEnabled = newvalue;
      if(newvalue === true){
        this.driverCheckbox = false;
        this.userCheckbox = false;
        this.adminCheckbox = false;
      }else{
        this.transportSelect = null;
        this.transportName = '';
      }
    },
    userCheckbox(newvalue){
      if(newvalue === true){
        this.transportCheckbox = false;
      }else{
        this.userProfileModel.passengerCost = null
      }
      if(newvalue || this.driverCheckbox || this.adminCheckbox){
        this.fureaiEnabled = true
      }else{
        this.fureaiEnabled = false
      }
    },
    driverCheckbox(newvalue){
      if(newvalue === true){
        this.transportCheckbox = false;
      }
      if(this.userCheckbox || newvalue || this.adminCheckbox){
        this.fureaiEnabled = true
      }else{
        this.fureaiEnabled = false
      }
    },

    // 交通事業者選択
    transportSelect(newvalue){
      this.userTransportDriverProfileModel.transportId = newvalue
      this.setTransportName()
    }
  },
  created () {
    // 父组件（UserEditor）传入的值赋值给子组件中Data中相应的属性
    this.driverCheckbox = this.driverCheckboxs
    this.userCheckbox = this.userCheckboxs
    this.adminCheckbox = this.adminCheckboxs
    this.transportCheckbox = this.transportCheckboxs
    this.permissionRadio = this.permissionRadios
    if (this.userDriverProfileModel.facePhotoUrl !== null) {
      this.option.img1 = this.userDriverProfileModel.facePhotoUrl
    }
    if (this.userDriverProfileModel.driverLicensePhotoUrl1 !== null) {
      this.option.img2 = this.userDriverProfileModel.driverLicensePhotoUrl1
    }
    if (this.userDriverProfileModel.driverLicensePhotoUrl2 !== null) {
      this.option.img3 = this.userDriverProfileModel.driverLicensePhotoUrl2
    }
    mHomeAddressChoiceByMap = this.userProfileModel.homeAddress

    if (sessionStorage.getItem('uploadPictureMaxSize') !== null) {
      this.uploadPictureMaxSize = parseInt(sessionStorage.getItem('uploadPictureMaxSize'))
    }
    this.getTransportInfoList()
    // 交通事業者初期値受け取り
    this.transportSelect = this.userTransportDriverProfileModel.transportId
  },

  methods: {
    // 检测图片1是否合规
    checkImage1 (e) {
      var file = e.target.files[0]
      return new Promise((resolve, reject) => {
        // 指定サイズ以下の画像を選択して下さい。
        if (file.size > this.uploadPictureMaxSize * 1024 * 1024) {
          this.showMessage(this.uploadPictureMaxSize + 'MBサイズ以下の画像を選択して下さい。')
          this.$refs.ctlImg1.value = ''
          return reject
        }
        // JPEG或はJPG形式の画像だけが選択できます。
        if (!/\.(jpg|jpeg|JPEG|JPG|png|PNG|bmp|BMP)$/.test(e.target.value)) {
          // alert('JPEG或はJPG形式の画像だけが選択できます。')
          this.showMessage('JPG、PNG或はBMP形式の画像だけが選択できます。')
          this.$refs.ctlImg1.value = ''
          return reject
        }
        var reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          let img = new Image()
          img.src = data
          img.onload = () => {
            // var width = img.width
            // var height = img.height
            // // ピクセル256×320以上の画像を選択して下さい。
            // if (width < 256 || height < 320) {
            //   // alert('ピクセル256×320以上の画像を選択して下さい。')
            //   this.showMessage('ピクセル256×320以上の画像を選択して下さい。')
            //   return reject
            // }
            this.option.file1 = file
            return resolve({
              data: data
            })
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 检测图片2是否合规
    checkImage2 (e) {
      var file = e.target.files[0]
      return new Promise((resolve, reject) => {
        // 指定サイズ以下の画像を選択して下さい。
        if (file.size > this.uploadPictureMaxSize * 1024 * 1024) {
          this.showMessage(this.uploadPictureMaxSize + 'MBサイズ以下の画像を選択して下さい。')
          this.$refs.ctlImg2.value = ''
          return reject
        }
        // JPEG或はJPG形式の画像だけが選択できます。
        if (!/\.(jpg|jpeg|JPEG|JPG|png|PNG|bmp|BMP)$/.test(e.target.value)) {
          // alert('JPEG或はJPG形式の画像だけが選択できます。')
          this.showMessage('JPG、PNG或はBMP形式の画像だけが選択できます。')
          this.$refs.ctlImg2.value = ''
          return reject
        }
        var reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          let img = new Image()
          img.src = data
          img.onload = () => {
            // var width = img.width
            // var height = img.height
            // // ピクセル256×320以上の画像を選択して下さい。
            // if (width < 256 || height < 320) {
            //   // alert('ピクセル256×320以上の画像を選択して下さい。')
            //   this.showMessage('ピクセル256×320以上の画像を選択して下さい。')
            //   return reject
            // }
            this.option.file2 = file
            return resolve({
              data: data
            })
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 检测图片1是否合规
    checkImage3 (e) {
      var file = e.target.files[0]
      return new Promise((resolve, reject) => {
        // 指定サイズ以下の画像を選択して下さい。
        if (file.size > this.uploadPictureMaxSize * 1024 * 1024) {
          this.showMessage(this.uploadPictureMaxSize + 'MBサイズ以下の画像を選択して下さい。')
          this.$refs.ctlImg3.value = ''
          return reject
        }
        // JPEG或はJPG形式の画像だけが選択できます。
        if (!/\.(jpg|jpeg|JPEG|JPG|png|PNG|bmp|BMP)$/.test(e.target.value)) {
          // alert('JPEG或はJPG形式の画像だけが選択できます。')
          this.showMessage('JPG、PNG或はBMP形式の画像だけが選択できます。')
          this.$refs.ctlImg3.value = ''
          return reject
        }
        var reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          let img = new Image()
          img.src = data
          img.onload = () => {
            // var width = img.width
            // var height = img.height
            // // ピクセル256×320以上の画像を選択して下さい。
            // if (width < 256 || height < 320) {
            //   // alert('ピクセル256×320以上の画像を選択して下さい。')
            //   this.showMessage('ピクセル256×320以上の画像を選択して下さい。')
            //   return reject
            // }
            this.option.file3 = file
            return resolve({
              data: data
            })
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 加载顔写真图片
    uploadImg1 (e) {
      this.checkImage1(e)
        .then(result => {
          if (result.data) {
            // 允许跳转
            this.option.img1 = result.data
          }
        })
        .catch(err => console.error(err))
    },
    // 加载免許証の写真图片
    uploadImg2 (e) {
      this.checkImage2(e)
        .then(result => {
          if (result.data) {
            // 允许跳转
            this.option.img2 = result.data
          }
        })
        .catch(err => console.error(err))
    },
    // 加载免許証の写真图片
    uploadImg3 (e) {
      this.checkImage3(e)
        .then(result => {
          if (result.data) {
            // 允许跳转
            this.option.img3 = result.data
          }
        })
        .catch(err => console.error(err))
    },
    // 点击顔写真を選択butto，图片选择dialog弹出
    chooseImage1 () {
      const event = new MouseEvent('click')
      this.$refs.ctlImg1.dispatchEvent(event)
    },
    // 点击免許証の写真を選択butto，图片选择dialog弹出
    chooseImage2 () {
      const event = new MouseEvent('click')
      this.$refs.ctlImg2.dispatchEvent(event)
    },
    // 点击免許証の写真を選択butto，图片选择dialog弹出
    chooseImage3 () {
      const event = new MouseEvent('click')
      this.$refs.ctlImg3.dispatchEvent(event)
    },
    // 根据checkbox拼接roleFlag
    getRoleFlag () {
      // 拼接roleFlag，roleFlag四位只含0和1的数字组成
      let role = ''
      // 会員checkbox被选中 第一位数字为1，否则为0
      if (this.userCheckbox) {
        role += '1'
      } else {
        role += '0'
      }
      // ドライバーcheckbox被选中 第二位数字为1，否则为0
      if (this.driverCheckbox) {
        role += '1'
      } else {
        role += '0'
      }
      // 管理者checkbox被选中
      if (this.adminCheckbox) {
        // 一般单选按钮被选中，第三位为1，第四位为0
        if (this.permissionRadio === 0 || this.permissionRadio === '0') {
          role += '10'
        } else {
          // マスター单选按钮被选中，第三位为0，第四位为1
          role += '01'
        }
      } else {
        // 管理者checkbox未被选中，第三位和第四位都为0
        role += '00'
      }
      // 交通事業者checkbox
      if (this.transportCheckbox) {
        role += '1'
      } else {
        role += '0'
      }
      this.userAccountModel.roleFlag = role
    },
    // 从日历子组件中传入出生年月
    getBirthday (selectValue) {
      this.birthday = selectValue
      // 校验出生年月日不能超过当前日期
      if (this.checkBirthday()) {
        // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
        let selectDate = DateUtil.calendarToDate(selectValue)
        // 将date格式转化为yyyyMMdd格式
        let forDate = formatDate(selectDate, 'yyyyMMdd')
        this.userProfileModel.birthday = forDate
        // 计算年龄
        this.age = DateUtil.yearCompute(forDate)
      } else {
        this.age = 0
      }
    },
    // 从日历子组件中传入免許証有効期限
    getDeadLine (selectValue) {
      // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
      let selectDate = DateUtil.calendarToDate(selectValue)
      // 将date格式转化为yyyyMMdd格式
      let forDate = formatDate(selectDate, 'yyyyMMdd')
      this.userDriverProfileModel.driverLicenseDeadline = forDate
    },
    // 从地图dialog弹出框中传入经度，纬度和地址
    getHomeAddress (selectValue) {
      this.userProfileModel.homeLat = selectValue.stationLat
      this.userProfileModel.homeLng = selectValue.stationLng
      this.userProfileModel.homeAddress = selectValue.address
      this.userProfileModel.postalcode = selectValue.postCode
      // 记录所选择的地址到该变量备用
      mHomeAddressChoiceByMap = selectValue.address
    },
    // 返回上一层
    goback () {
      this.$router.go(-1)
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 校验出生年月不能大于现在时间
    checkBirthday () {
      let birthday = DateUtil.calendarToDate(this.birthday)
      if (birthday > new Date()) {
        this.showMessage('生年月日は登録日以降の日付入力ができません。')
        return false
      }
      return true
    },
    // 将数据传入后台
    commitServer () {
      new Promise((resolve, reject) => {
        // 如果选择driver
        if (this.driverCheckbox) {
          // 如果顔写真图片,免許証の写真图片1,免許証の写真图片2都未被编辑，则无需上传图片
          if (this.option.file1 === null && this.option.file2 === null && this.option.file3 === null) {
            resolve()
          } else {
            let formData = new FormData()
            // 顔写真图片
            formData.append('uploadFile1', this.option.file1 !== null ? this.option.file1 : null)
            // 免許証の写真图片
            formData.append('uploadFile2', this.option.file2 !== null ? this.option.file2 : null)
            // 免許証の写真图片
            formData.append('uploadFile3', this.option.file3 != null ? this.option.file3 : null)
            this.$axios.post('user/saveUserImage', formData)
              .then((response) => {
                if (response.data.pictureUrl1 !== null) {
                  this.userDriverProfileModel.facePhotoUrl = response.data.pictureUrl1
                }
                if (response.data.pictureUrl2 !== null) {
                  this.userDriverProfileModel.driverLicensePhotoUrl1 = response.data.pictureUrl2
                }
                if (response.data.pictureUrl3 !== null) {
                  this.userDriverProfileModel.driverLicensePhotoUrl2 = response.data.pictureUrl3
                }
                resolve()
              })
              .catch((error) => {
                console.log(error)
              })
          }
        } else {
          resolve()
        }
      }).then(() => {
        this.$axios
          .post('user/SaveUserInfo', {
            userProfile: this.userProfileModel,
            userDriverProfile: this.driverCheckbox
              ? this.userDriverProfileModel
              : null,
            userAccount: this.userAccountModel,
            userTransportDriverProfile: this.transportCheckbox
              ? this.userTransportDriverProfileModel
              : null
          })
          .then(() => {
          // 数据保存成功 返回到管理画面
            this.$router.push({ name: 'MemberList' })
          })
          .catch((error) => {
          // 测试使用 待删除 TODO
            this.showMessage('予期せぬエラーが発生しました。')
            console.log(error)
          })
      })
    },
    // 前台数据提交
    submit () {
      // 料金が空の場合はnullを登録
      if(this.userProfileModel.passengerCost === ''){
        this.userProfileModel.passengerCost = null
      }
      // 获取a标签Dom
      let model = document.getElementById('modal-475051')
      // 每次进来地址为空不跳转
      model.href = 'javascript:void(0)'
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.checkBirthday()) {
          // 获取roleFlag
            this.getRoleFlag()
            // 验证通过跳转
            model.href = '#modal-container-475051'
            // 信息确认画面 点击确认按钮
            this.$refs.userInfoDialog
              .confirm()
              .then(() => {
                if (this.functionFlag === '1') {
                  this.userDriverProfileModel.joinDate = this.getJoinDate()
                }
                // 将数据传到后台
                this.commitServer()
              })
          }
        }
      })
    },
    getJoinDate () {
      // 将yyyy年MM月dd日转化为yyyyMMdd
      return DateUtil.getYearMonthDay(this.driverInTime)
    },
    // 调用谷歌API，根据输入地址查询经纬度和邮编
    getMapResult (address) {
      var geocoder = new global.google.maps.Geocoder()
      var promise = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === 'OK') {
            resolve(results[0])
          } else {
            reject(new Error('MAP_ERROR'))
          }
        })
      })
      return promise
    },
    // 根据输入的地址获取经纬度
    getLatLng () {
      // 住所未入力时
      if (this.userProfileModel.homeAddress == null || this.userProfileModel.homeAddress.length === 0) {
        this.userProfileModel.homeLat = 0
        this.userProfileModel.homeLng = 0
        return
      }

      if (/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g.test(this.userProfileModel.homeAddress)) {
        return
      }

      // 输入框中的地址和之前地图上选择的点的地址一样时经纬度保持之前选择的不变
      if (mHomeAddressChoiceByMap !== '' && mHomeAddressChoiceByMap === this.userProfileModel.homeAddress) {
        return
      }
      mHomeAddressChoiceByMap = ''
      // 调用谷歌API，根据输入地址查询经纬度和邮编
      this.getMapResult(this.userProfileModel.homeAddress)
        .then(result => {
          // 经度
          this.userProfileModel.homeLat = result.geometry.location.lat()
          // 纬度
          this.userProfileModel.homeLng = result.geometry.location.lng()
          let len = result.address_components.length
          let postCode = result.address_components[len - 1].short_name
          if (postCode !== undefined && postCode !== '') {
            if (/^\d{3}-?\d{4}$/.test(postCode)) {
              // 邮编
              this.userProfileModel.postalcode = postCode
            } else {
              this.userProfileModel.postalcode = ''
            }
          } else {
            this.userProfileModel.postalcode = ''
          }
        })
        .catch(error => {
          this.showMessage('緯度経度変換に失敗しました。')
          // 根据选择的地址取不到经纬度，则给其赋值为0
          this.userProfileModel.homeLat = 0
          this.userProfileModel.homeLng = 0
          // 取不到邮编，则将邮编置为空
          this.userProfileModel.postalcode = ''
          console.log(error)
        })
    },
    // 自动根据邮编获取地址
    autoGetAddress () {
      // this.userProfileModel.portableTelephone = this.userProfileModel.portableTelephone + '5'
      this.$refs.test.onkeyup()
      setTimeout(() => {
        if (!StringUtil.isEmpty(this.$refs.autoAddress.value)) {
          this.userProfileModel.homeAddress = this.$refs.autoAddress.value
          this.getMapResult(this.userProfileModel.homeAddress)
            .then(result => {
              this.userProfileModel.homeLat = result.geometry.location.lat()
              this.userProfileModel.homeLng = result.geometry.location.lng()
            })
            .catch(error => {
              // this.showMessage('該当住所の経緯度取得できません。マップで探してください。')
              // 根据选择的地址取不到经纬度，则给其赋值为0
              this.userProfileModel.homeLat = 0
              this.userProfileModel.homeLng = 0
              console.log(error)
            })
        } else {
          this.userProfileModel.homeAddress = ''
          this.userProfileModel.homeLat = 0
          this.userProfileModel.homeLng = 0
          this.showMessage('住所が取得できません。郵便番号を確認してください。')
        }
        this.$refs.autoAddress.value = ''
        mHomeAddressChoiceByMap = ''
      }, 100)
    },
    initAddressChoice () {
      // 设置图标样式
      let vehiclePoint = {
        name: this.userProfileModel.homeAddress,
        postCode: this.userProfileModel.postalcode,
        lat: Number(this.userProfileModel.homeLat),
        lng: Number(this.userProfileModel.homeLng),
        icon: mapDropPin
      }
      // 设置图标大小
      let imgSize = {width: 20, height: 54}
      // this.this.$refs.centerPoint = this.centerPoint
      // this.$refs.homeAddressChoice.initAddressChoice(vehiclePoint, imgSize)
      // this.$refs.homeAddressChoice.searchAddress = this.userProfileModel.homeAddress
      // this.$refs.homeAddressChoice.searchPlaceEvnet()
      // this.$refs.homeAddressChoice.searchAddress = ''
      // let viewModel = {address: this.userProfileModel.homeAddress}
      // this.$refs.homeAddressChoice.viewModel = viewModel
      this.$refs.homeAddressChoice.initAddressChoice(vehiclePoint, imgSize)
    },
    changePassword (val) {
      this.$store.commit('SET_PASSWORD', val)
    },
    // 交通事業者一覧取得
    getTransportInfoList(){
      this.$axios
        .get('user/getTransportInfoList', {
          params: {}
        })
        .then(response => {
          this.transportInfoList = response.data.transportInfoList
          this.setTransportName()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setTransportName(){
      for(let i = 0; i < this.transportInfoList.length; i++){
        if(this.transportInfoList[i].transportId == this.userTransportDriverProfileModel.transportId){
          this.transportName = this.transportInfoList[i].transportName
        }
      }
    }
  }
}
</script>

<template>
  <div class="col-md-12 column" style="width:100%;height:70vh;display:flex;flex-direction: column;flex:1">
    <div class="row clearfix" style="flex: 0 0 40px">
      <div class="col-md-12 column">
        <div class="row clearfix">
          <div class="col-md-12 column T7-title F2-M-27">
            {{title}}
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-3 column clearfix" style="min-width: 320px;margin-left: 2%">
            <span class="F3-R-14">※必須項目</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix slider" style="flex: 1 1 0">
      <div class="col-md-1 column">
      </div>
      <div class="col-md-10 column" style="margin-left: 10%">
        <div class="row clearfix">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    権限
                  </div>
                </div>
              </div>
              <div class="col-md-2 column checkBoxDiv" style="width: 9%;min-width: 110px;">
                <label class="checkbox-inline">
                  <input type="checkbox" name="role1" v-validate="{required: !driverCheckbox&&!adminCheckbox&&!transportCheckbox}" v-model="userCheckbox" :disabled="transportEnabled" class="btn btn-default radiobutton" />
                  <span></span>
                  <span class="F3-R-20">会員</span>
                </label>
              </div>
              <div class="col-md-2 column checkBoxDiv paddingLeftZero" style="width: 12%;min-width: 150px;">
                <label class="checkbox-inline">
                  <input type="checkbox" name="role2" v-model="driverCheckbox" :disabled="transportEnabled" class="btn btn-default radiobutton" />
                  <span></span>
                  <span class="F3-R-20">ドライバー</span>
                </label>
              </div>
              <div class="col-md-2 column checkBoxDiv paddingLeftZero textAlignLeft" style="width: 9%;min-width: 120px;">
                <label class="checkbox-inline">
                  <input type="checkbox" name="role3" v-model="adminCheckbox" :disabled="transportEnabled" class="btn btn-default radiobutton" />
                  <span></span>
                  <span class="F3-R-20">管理者</span>
                </label>
              </div>
              <div class=" col-md-2 radiodiv textAlignLeft paddingLeftZero" style="margin-left: -1%;">
                <label style="font-weight: normal">(</label>
                <label class="radio-inline" style="margin-right: 4%;">
                  <input class="radiobutton" type="radio" name="permissionIdRadio" v-model="permissionRadio" :disabled="transportEnabled" id="normalRadio" value="0" checked>
                  <span></span>
                  <span class="F3-R-20">一般</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="permissionIdRadio" v-model="permissionRadio" :disabled="transportEnabled" id="masterRadio" value="1">
                  <span></span>
                  <span class="F3-R-20">マスター</span>
                </label>
                <label style="font-weight: normal">)</label>
              </div>
              <div class="col-md-2 column checkBoxDiv paddingLeftZero textAlignLeft" style="width: 9%;min-width: 158px;">
                <label class="checkbox-inline">
                  <input type="checkbox" name="role4" v-model="transportCheckbox" :disabled="fureaiEnabled" class="btn btn-default radiobutton" />
                  <span></span>
                  <span class="F3-R-20">交通事業者</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column errorMessageDiv textAlignLeft">
            <span v-show="errors.has('role1')" class="errorMessage"> {{ errors.first('role1') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    フリガナ
                  </div>
                </div>
              </div>
              <div class="col-md-6 column shortInput">
                <div class="row clearfix">
                  <div class="col-md-12 column">
                    <div class="row clearfix">
                      <div class="col-md-6 column paddingRightZero">
                        <input type="text" name="kanaSecond" v-validate="'required|paintWordNo'" v-model="userProfileModel.lastNameKana" maxlength="25" class="inputstyles F3-R-20"/>
                      </div>
                      <div class="col-md-6 column paddingLeftZero" style="margin-left:-1px;">
                        <input type="text" name="kanaFirst" v-validate="'required|paintWordNo'" v-model="userProfileModel.firstNameKana" maxlength="25" class="inputstyles F3-R-20"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='0'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    生年月日
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" v-if="functionFlag==='0'">
                <calendar-input @getValue="getBirthday" :input-style="'height: 50px;font-size: 16px;padding-left:12px'" :selectY="birthdayYear"
                  :selectM="birthdayMonth" :selectD="birthdayDay">
                </calendar-input>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='1'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    パスワード
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput" v-if="functionFlag==='1'">
                <input type="text" name="password" v-validate="'required|passwordValidator'" v-model="userAccountModel.password"
                  maxlength="8" class="inputstyles F3-R-20" :onKeyUp="changePassword(userAccountModel.password)"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-6 column shortInput textAlignLeft">
            <span v-if="errors.has('kanaSecond')" class="errorMessage"> {{ errors.first('kanaSecond') }} </span>
            <span v-else-if="errors.has('kanaFirst')" class="errorMessage"> {{ errors.first('kanaFirst') }} </span>
          </div>
          <div class="col-md-2 column  shortDiv">
          </div>
          <div class="col-md-2 column shortInput textAlignLeft" >
            <span v-show="errors.has('password')" class="errorMessage"> {{ errors.first('password') }} </span>
          </div>
        </div>
        <div class="row clearfix" :class="{marginBig:functionFlag==='1',marginSmall:functionFlag==='0'}"  >
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    氏名
                  </div>
                </div>
              </div>
              <div class="col-md-6 column shortInput">
                <div class="row clearfix">
                  <div class="col-md-12 column">
                    <div class="row clearfix">
                      <div class="col-md-6 column paddingRightZero">
                        <input type="text" name="nameSecond" v-validate="'required|paintWordNo'" v-model="userProfileModel.lastName" maxlength="25" class="inputstyles F3-R-20"/>
                      </div>
                      <div class="col-md-6 column paddingLeftZero" style="margin-left:-1px;">
                        <input type="text" name="nameFirst" v-validate="'required|paintWordNo'" v-model="userProfileModel.firstName" maxlength="25" class="inputstyles F3-R-20"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='0'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    年齢
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput"  v-if="functionFlag==='0'">
                <div class="divTitle longsolid bgc5 F3-R-20">{{age}}才</div>
              </div>

              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='1'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    生年月日
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" v-if="functionFlag==='1'">
                <calendar-input @getValue="getBirthday" :input-style="'height: 50px;font-size: 16px;padding-left:12px'" :selectY="birthdayYear"
                  :selectM="birthdayMonth" :selectD="birthdayDay">
                </calendar-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-if="errors.has('nameSecond')" class="errorMessage"> {{ errors.first('nameSecond') }} </span>
            <span v-else-if="errors.has('nameFirst')" class="errorMessage"> {{ errors.first('nameFirst') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop" :class="{marginSmall:functionFlag==='1',marginBig:functionFlag==='0'}">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    性別
                  </div>
                </div>
              </div>
              <div class=" col-md-6 radiodiv textAlignLeft shortInput">
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="sexualIdRadio" v-model="userProfileModel.sex" value="0">
                  <span></span>
                  <span class="F3-R-20">男性</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="sexualIdRadio" v-model="userProfileModel.sex" value="1">
                  <span></span>
                  <span class="F3-R-20">女性</span>
                </label>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='0'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding-left: 10px">
                    登録日
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" v-if="functionFlag==='0'">
                <div class="divTitle longsolid bgc5 F3-R-20">{{inTime}}</div>
              </div>
              <div class="col-md-2 column divTitle shortDiv" v-if="functionFlag==='1'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    年齢
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput"  v-if="functionFlag==='1'">
                <div class="divTitle longsolid bgc5 F3-R-20">{{age}}才</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column shortDiv divTitle">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    郵便番号
                  </div>
                </div>
              </div>
              <div class="col-md-4 column autoInput">
                <input type="text" name="postCode" v-validate="'required|specialNumber'"
                  v-model="userProfileModel.postalcode" maxlength="25" placeholder="(例：000-0000)"
                  class="inputstyles F3-R-20" ref="test" onKeyUp="AjaxZip3.zip2addr(this,'','tempAddress','tempAddress')"/>
              </div>
              <div class="col-md-2 column shortDiv paddingLeftZero paddingRightZero">
                <button style="width:100%" class="T7-radius F2-R-19" @click="autoGetAddress">
                  住所を自動入力
                </button>
              </div>
              <div class="col-md-2 column divTitle shortDiv " style="margin-left:20px" v-if="functionFlag==='1'">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding-left: 10px">
                    登録日
                  </div>
                </div>
              </div>
              <div class="col-md-2 column shortInput" v-if="functionFlag==='1'">
                <div class="divTitle longsolid bgc5 F3-R-20">{{inTime}}</div>
              </div>
              <div class="col-md-2 column" v-show="false">
                <input type="text" name="tempAddress" ref="autoAddress" />
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('postCode')" class="errorMessage"> {{ errors.first('postCode') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column shortDiv divTitle">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    自宅住所
                  </div>
                </div>
              </div>
              <div class="col-md-8 column" style="width:68.5%">
                <input type="text" name="address" v-validate="'required|paintWordNo'" maxlength="50" v-model="userProfileModel.homeAddress" @blur="getLatLng" class="inputstyles F3-R-20"/>
              </div>
              <div class="col-md-2 column shortDiv paddingLeftZero paddingRightZero">
                  <button style="width:100%" class="T7-radius F2-R-19" href="#modal-container-addressChoice" data-toggle="modal" @click="initAddressChoice" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                    マップで探す
                  </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('address')" class="errorMessage"> {{ errors.first('address') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                    ※
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    電話番号
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput">
                <input type="text" name="phone" v-validate="'required|specialNumber'"
                 v-model="userProfileModel.homeTelephone" maxlength="25" class="inputstyles F3-R-20" placeholder="(例：000-000-0000)" />
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('phone')" class="errorMessage"> {{ errors.first('phone') }} </span>
          </div>
        </div>
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix textAlignLeft">
                  </div>
                  <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                    携帯番号
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput">
                <input type="text" name="carryNumber" v-validate="'specialNumber'" v-model="userProfileModel.portableTelephone"
                  maxlength="25" class="inputstyles F3-R-20" placeholder="(例：000-0000-0000)" />
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('carryNumber')" class="errorMessage"> {{ errors.first('carryNumber') }} </span>
          </div>
        </div>
        <!-- FAXX -->
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix"></div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    FAX
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput">
                <input type="text" name="fax" v-validate="'specialNumber'"
                v-model="userProfileModel.fax" maxlength="25"
                class="inputstyles F3-R-20" placeholder="(例：000-000-0000)" />
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('fax')" class="errorMessage"> {{ errors.first('fax') }} </span>
          </div>
        </div>
        <!-- 料金 一般会員のみ -->
        <div class="row clearfix divMarginTop" v-if="userCheckbox">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-2 column divTitle shortDiv">
                <div class="row clearfix F3-R-15 bgc8">
                  <div class="col-md-4 column clearfix"></div>
                  <div class="col-md-8 column clearfix textAlignLeft">
                    料金
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput" style="display:flex;">
                <input type="text" name="passengerCost" v-validate="'numeric'"
                v-model="userProfileModel.passengerCost" maxlength="5"
                class="inputstyles F3-R-20" 
                style="margin-left: 0; display:block; width: 200px;"/>
                <span style="margin-left: 12px; font-size: 20px; line-height: 50px;">円</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-2 column shortDiv">
          </div>
          <div class="col-md-10 column textAlignLeft">
            <span v-show="errors.has('passengerCost')" class="errorMessage"> {{ errors.first('passengerCost') }} </span>
          </div>
        </div>
        <!-- ビコー -->
        <div class="row clearfix divMarginTop">
          <div class="col-md-12 column">
            <div class="row clearfix F3-R-15 ">
              <div class="col-md-2 column divTitle shortDiv bgc8" style="height: 150px; line-height: 150px;">
                備考
              </div>
              <div class="col-md-10 column">
                <textarea v-validate="'paintWordNo'" rows="8" cols="133" name="note"
                v-model="userProfileModel.note" maxlength="256" class="textareastyle F3-R-20"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 column">
            <div class="row clearfix F3-R-15 " style="margin-top:-8px">
              <div class="col-md-2 column shortDiv">
              </div>
              <div class="col-md-10 column textAlignLeft">
                <span v-show="errors.has('note')" class="errorMessage"> {{ errors.first('note') }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix bottomDiv" v-show="driverCheckbox">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-12 column T7-longtitle F2-M-19 bgc3" style="text-align: center;">
                ドライバー項目
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-2 column divMarginTop">
                <img v-if="option.img1!==null" :src="option.img1" class="imageStyle">
                <div v-else class="imageStyle noimg-style bgc10 F2-M-18">No Image</div>
              </div>
              <div class="col-md-4 column">
                <div class="row clearfix">
                  <div class="col-md-12 column">
                    <input ref="ctlImg1" class="fileInput" name="uploadPicture" v-validate="{required: driverCheckbox&&option.img1===null}" type="file"
                      accept="image/png, image/jpeg, image/bmp, image/jpg" @change="uploadImg1($event)">
                    <button id="imgSelect" style="float:left;margin-top:60px;" type="button" class="T7-radius F2-R-19" @click="chooseImage1">※顔写真を選択</button>
                  </div>
                </div>
                <div class="row clearfix">
                  <div class="col-md-12 column textAlignLeft divMarginTop paddingRightZero F3-R-14">
                    ※最大アップロードファイルサイズ{{uploadPictureMaxSize}}MB
                  </div>
                </div>
              </div>
              <div class="col-md-6 column">
                <div class="row clearfix divMarginTop">
                  <div class="col-md-4 column clearfix divTitle itemDiv">
                    <div class="row clearfix">
                      <div class="column clearfix F3-R-15 bgc8">
                        ※免許証有効期限
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 column">
                    <calendar-input @getValue="getDeadLine" class="itemInput" :input-style="'height: 50px;font-size: 16px;padding-left:12px;background-color:white'"
                      :selectY="driverLicenseDeadlineYear" :selectM="driverLicenseDeadlineMonth" :selectD="driverLicenseDeadlineDay">
                    </calendar-input>
                  </div>
                </div>
                <div class="row clearfix divMarginTop">
                  <div class="col-md-4 column clearfix itemDiv divTitle">
                    <div class="row clearfix">
                      <div class="column clearfix F3-R-15 bgc8">
                        ドライバー登録日
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 column">
                    <div class="divTitle longsolid itemInput bgc5 F3-R-20">{{driverInTime}}</div>
                  </div>
                </div>
                <div class="row clearfix divMarginTop">
                  <div class="col-md-4 column clearfix divTitle itemDiv">
                    <div class="row clearfix">
                      <div class="column clearfix F3-R-15 bgc8">
                        活動年数
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 column">
                    <div class="divTitle longsolid itemInput bgc5 F3-R-20">{{activityYear}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-12 column textAlignLeft">
                <span v-show="errors.has('uploadPicture')" class="errorMessage"> {{ errors.first('uploadPicture') }} </span>
              </div>
            </div>
            <div class="row clearfix itemMargin" style="margin-top:20px;">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column shortDiv divTitle F3-R-15 bgc8">
                    事故歴
                  </div>
                  <div class="col-md-10 column radiodiv textAlignLeft">
                    <label class="radio-inline" style="margin-right: 5%">
                      <input class="radiobutton" type="radio" name="eventIdRadio" v-model="userDriverProfileModel.accidentFlag" value="1">
                      <span></span>
                      <span class="F3-R-20">あり</span>
                    </label>
                    <label class="radio-inline">
                      <input class="radiobutton" type="radio" name="eventIdRadio" v-model="userDriverProfileModel.accidentFlag" value="0">
                      <span></span>
                      <span class="F3-R-20"> なし</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin divMarginTop">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column divTitle shortDiv F3-R-15 bgc8">
                    事故内容
                  </div>
                  <div class="col-md-10 column">
                    <input type="text" v-model="userDriverProfileModel.accidentDetails" v-validate="{paintWordNo: driverCheckbox}"
                      name="accident" style="width: 104%" maxlength="200" class="inputstyles F3-R-20"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-10 column textAlignLeft">
                    <span v-show="errors.has('accident')" class="errorMessage"> {{ errors.first('accident') }} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin divMarginTop">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column shortDiv divTitle F3-R-15 bgc8">
                    行政処分
                  </div>
                  <div class="col-md-10 column radiodiv textAlignLeft">
                    <label class="radio-inline" style="margin-right: 5%">
                      <input class="radiobutton" type="radio" name="adminIdRadio" v-model="userDriverProfileModel.sanctionFlag" value="1">
                      <span></span>
                      <span class="F3-R-20">あり</span>
                    </label>
                    <label class="radio-inline">
                      <input class="radiobutton" type="radio" name="adminIdRadio" v-model="userDriverProfileModel.sanctionFlag" value="0">
                      <span></span>
                      <span class="F3-R-20"> なし</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin divMarginTop">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column divTitle shortDiv F3-R-15 bgc8">
                    処分内容
                  </div>
                  <div class="col-md-10 column">
                    <input type="text" v-model="userDriverProfileModel.sanctionDetails" v-validate="{paintWordNo: driverCheckbox}"
                      name="sanction" maxlength="200" class="inputstyles F3-R-20" style="width:104%;"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-10 column textAlignLeft">
                    <span v-show="errors.has('sanction')" class="errorMessage"> {{ errors.first('sanction') }} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix itemMargin divMarginTop">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column shortDiv divTitle F3-R-15 bgc8">
                    報酬対象
                  </div>
                  <div class="col-md-10 column radiodiv textAlignLeft">
                    <label class="radio-inline" style="margin-right: 5%">
                      <input class="radiobutton" type="radio" name="moneyIdRadio" v-model="userDriverProfileModel.rewardFlag" value="1">
                      <span></span>
                      <span class="F3-R-20">あり</span>
                    </label>
                    <label class="radio-inline">
                      <input class="radiobutton" type="radio" name="moneyIdRadio" v-model="userDriverProfileModel.rewardFlag" value="0">
                      <span></span>
                      <span class="F3-R-20"> なし</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix divMarginTop">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-5 column">
                    <img v-if="option.img2!==null" :src="option.img2" class="idImageStyle">
                    <div v-else class="idImageStyle noimg-style bgc10 F2-M-18">No Image</div>
                  </div>
                  <div class="col-md-7 column">
                    <div class="row clearfix">
                      <div class="col-md-12 column">
                        <input ref="ctlImg2" class="fileInput" type="file" accept="image/png, image/jpeg, image/bmp, image/jpg" @change="uploadImg2($event)">
                        <button id="imgSelect" style="float:left;margin-top:60px;" type="button" class="T7-radius F2-R-19" @click="chooseImage2">免許証の写真を選択</button>
                      </div>
                    </div>
                    <div class="row clearfix">
                      <div class="col-md-12 column textAlignLeft divMarginTop F3-R-14">
                        ※最大アップロードファイルサイズ{{uploadPictureMaxSize}}MB
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix" style="margin-top:15px; margin-bottom:5px; ">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-5 column">
                    <img v-if="option.img3!==null" :src="option.img3" class="idImageStyle">
                    <div v-else class="idImageStyle noimg-style bgc10 F2-M-18">No Image</div>
                  </div>
                  <div class="col-md-7 column">
                    <div class="row clearfix">
                      <div class="col-md-12 column">
                        <input ref="ctlImg3" class="fileInput" type="file" accept="image/png, image/jpeg, image/bmp, image/jpg" @change="uploadImg3($event)">
                        <button id="imgSelect" style="float:left;margin-top:60px;" type="button" class="T7-radius F2-R-19" @click="chooseImage3">免許証の写真を選択</button>
                      </div>
                    </div>
                    <div class="row clearfix">
                      <div class="col-md-12 column textAlignLeft divMarginTop F3-R-14">
                        ※最大アップロードファイルサイズ{{uploadPictureMaxSize}}MB
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row clearfix bottomDiv" v-show="transportCheckbox">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-12 column T7-longtitle F2-M-19 bgc3" style="text-align: center;">
                交通事業者項目
              </div>
            </div>
            <div class="row clearfix" style="margin-top:15px; margin-bottom:5px; ">
              <div class="col-md-12 column">
                <div class="row clearfix">
                  <div class="col-md-2 column divTitle shortDiv F3-R-15 bgc8">
                      交通事業者
                  </div>
                  <div class="col-md-5 column">
                    <select class="inputstyles selectImg F3-R-20"
                    name="selectTransport" v-validate="{required: transportCheckbox}"  v-model="transportSelect">
                      <option v-for='item in transportInfoList' :key="item.transportId" :value="item.transportId">
                        {{item.transportName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix">
              <div class="col-md-2 column shortDiv">
              </div>
              <div class="col-md-10 column errorMessageDiv textAlignLeft" style="margin-top: 0">
                <span v-show="errors.has('selectTransport')" class="errorMessage"> {{ errors.first('selectTransport') }} </span>
              </div>
            </div>
          </div>
        </div>
        <driver :title="title" :birthday="birthday" :option="option" :adminCheckbox="adminCheckbox" :userCheckbox="userCheckbox" :permissionRadio="permissionRadio+''"
          :userProfileModel="userProfileModel" :inTime="inTime" :driverInTime="driverInTime" :age="age" :activityYear="activityYear"
          :userDriverProfileModel="userDriverProfileModel" :driverCheckbox="driverCheckbox"
          :transportCheckbox="transportCheckbox" :transportName="transportName" ref="userInfoDialog"></driver>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
        <addressChoice @getAddress="getHomeAddress" ref="homeAddressChoice"></addressChoice>
      </div>
      <div class="col-md-1 column">
      </div>
    </div>
    <div class="row clearfix" style="margin-bottom:30px;">
      <div class="col-md-1 column">
      </div>
      <div class="col-md-10 column" style="margin-left: 10%">
        <div class="row clearfix">
          <div class="col-md-6 column">
            <a id="modal-475051" @click="submit()" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
              <button class="T7-larginbtn window-button" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">{{btnName}}</button>
            </a>
          </div>
          <div class="col-md-6 column">
            <button class="T7-larginbtn window-button" style="margin-left: -30%;" @click="goback">キャンセル</button>
          </div>
        </div>
      </div>
      <div class="col-md-1 column">
      </div>
    </div>
  </div>
</template>

<style scoped>
.T7-title {
  margin-top: 25px;
  font-size: 25px;
  color: black;
}
.T7-tip {
  width: 150px;
  background: #cecece;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: black;
}
.divTitle {
  background: #cecece;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: black;
}
.T7-longbtn {
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
}
.T7-radius {
  width: 100%;
  max-width: 200px;
  height: 50px;
  background: linear-gradient(#a4a4a2 50%, rgb(138, 138, 138) 50%);
  border-radius: 30px;
  text-align: center;
  padding: 0;
  border: 0;
}
.T7-shortbtn {
  width: 100%;
  float: left;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
}
.T7-longtitle {
  width: 100%;
  background: #cecece;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  text-align: left;
  font-weight: 550;
  color: black;
}
.T7-larginbtn {
  width: 85%;
  background: rgb(109, 109, 109);
  color: #ffffff;
  font-size: 20px;
  border-radius: 10px;
  height: 50px;
}
.inputstyles {
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  border-radius: 0px;
  padding-left: 10px;
  border:1px solid #ccc;
}
.radiodiv {
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
.checkBoxDiv {
  font-size: 18px;
  margin-top: 5px;
  text-align: left;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
input[type="checkbox"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
.rightwidth {
  width: 450px;
}
.leftwidth {
  width: 450px;
}
.textareastyle {
  width: 100%;
  height: 150px;
  font-size: 16px;
  border: solid 1px #ccc;
  padding: 6px 12px;
  resize: none;
}
.longsolid {
  font-size: 16px;
  padding: 0px 12px;
  text-align: left;
}
.selfdiv {
  width: 50%;
  height: 50px;
  text-align: left;
  margin-top: 13px;
  font-size: 16px;
}
.fileInput {
  position: absolute;
  clip: rect(0 0 0 0);
}
.imageStyle {
  width: 100%;
  height: 200px;
}
.idImageStyle {
  width: 100%;
  height: 350px;
}
.textAlignLeft {
  text-align: left;
}
.textAlignRight {
  text-align: right;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.shortInput {
  width: 35%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.bottomDiv {
  margin-top: 20px;
  background: rgb(234, 234, 234);
  width: 97.3%;
  min-width: 816px;
}
.itemDiv {
  width: 28%;
  min-width: 130px;
}
.itemInput {
  width: 107%;
}
.itemMargin {
  margin-left: 0.01%;
}
.divMarginTop {
  margin-top: 10px;
}
.errorMessageDiv {
  margin-top: -10px;
  margin-bottom: 10px;
}
.errorMessage {
  color: red;
}
.wordBre {
  word-break: break-all;
}
.noimg-style{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .autoInput{
    width: 20.5%;
  }
  .marginBig{
    margin-top:10px
  }
  .marginSmall{
    margin-top:5px
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfoComponent.vue